import lazyLoadOnRender from '@ms/yammer-web-components/dist/lazy/loadOnRender';

const TeamsSubHeader = () => import(/* webpackChunkName: "4-feat-teamssubheader" */ './TeamsSubHeader');

export default lazyLoadOnRender({ loader: TeamsSubHeader });
